import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { HistoryPayment } from './settings/HistoryPayment';
import { PaymentMethodList } from './settings/PaymentMethodList';
import { PaymentStatus } from './settings/PaymentStatus';
import { PaymentInfo } from './settings/PaymentInfo';
import { CancelSubscription } from './settings/CancelSubscription';
import { apiSubscription } from '../../api/apiSubscription.api';
import DotSpinner from '../../components/shared/DotSpinner';
import { Acceptance } from './Acceptance';

const mapSubscribe = (sub) => {
  return {
    tire: sub.tire,
    isActive: sub.isActive,
    status: sub.subscription.status,
    payment: sub.subscription.payment,
    nextPayment: {
      amount:
        sub.subscription?.product?.prices?.find((p) => p.currency === sub.subscription.payment.currency)?.amount ??
        null,
      date: sub.subscription?.endPeriod ?? null,
    },
  };
};

export function SubscriptionSettings() {
  const axiosPrivate = useAxiosPrivate();

  const [subscribe, setSubscribe] = useState(null);

  const fetchSub = useCallback(() => {
    apiSubscription.activeSub(axiosPrivate).then((res) => setSubscribe(mapSubscribe(res)));
  }, [axiosPrivate]);

  useEffect(() => {
    fetchSub();
  }, [fetchSub]);

  if (!subscribe) {
    return (
      <div className="flex items-center justify-center min-h-[100vh]">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 p-4 pb-[21px]">
      <PaymentStatus subscribe={subscribe} onRefresh={fetchSub} />
      <PaymentInfo />
      {/* <PaymentMethodList /> */}
      <HistoryPayment />
      <div className="flex flex-col gap-2 items-start">
        <Acceptance />
        {subscribe.isActive && <CancelSubscription onSuccess={fetchSub} />}
      </div>
    </div>
  );
}
